import { queryStringToObject, toQueryString } from '@fiverr-private/futile';

const updateQueryParams = (queryParams, global = window) => {
    // Check is we are in the browser
    if (global) {
        const querySearch = global.location.search ? global.location.search.replace(/^\?/, '') : '';
        const queryObject = {
            ...queryStringToObject(querySearch),
            ...queryParams,
        };
        const updatedHref = `${global.location.pathname}?${toQueryString(queryObject)}`;

        global.history.replaceState({}, global.document.title, updatedHref);
    }
};

export default updateQueryParams;
